// @flow strict
import * as React from "react";
import { imgSrc } from "~common/utils";
import { PATHS, AVATAR_PLAYER, NAME_PLAYER } from "~robin-hood/utils";
import type { Player } from "~robin-hood/utils";
import styles from "./Toolbar.module.css";
import { withRouter } from "react-router-dom";
import type { RouterHistory } from "react-router-dom";
import classnames from "~common/classnames";
import type { Equipo, Agent, RegisteredStore } from "~robin-hood/redux/store";
import {
  PRUEBAS,
  getAgentPlayers,
  knowsPlayerSecret,
} from "~robin-hood/redux/store";

const ICONOS = {
  consola: "CONSOLA.png",
  digitos: "DIGITOS.png",
  ahorcado: "AHORCADO.png",
  poker: "POKER.png",
  colores: "COLORES.png",
  casillas: "CASILLAS.png",
  sonidos: "SONIDOS.png",
  final: "DINERO.png",
};
const PRUEBAS_ROUTE = {
  consola: PATHS.CONSOLA,
  digitos: PATHS.DIGITOS,
  ahorcado: PATHS.AHORCADO,
  poker: PATHS.POKER,
  colores: PATHS.COLORES,
  casillas: PATHS.CASILLAS,
  sonidos: PATHS.SONIDOS,
  final: PATHS.FINAL,
};

const PRUEBAS_TOOLBAR = [...PRUEBAS, "final"];

type RouteKey = $Keys<typeof PRUEBAS_ROUTE>;

type ToolbarProps = {
  agent: Agent,
  equipo: Equipo,
  player: Player,
  store: RegisteredStore,
};
export function Toolbar(props: ToolbarProps): React$Node {
  return (
    <React.Fragment>
      <Avatar
        agent={props.agent}
        store={props.store}
        equipo={props.equipo}
        player={props.player}
      />
      <div
        className={classnames(
          styles.Toolbar,
          props.equipo.endTime != null && styles.hideToolbar
        )}
      >
        <div className={styles.ToolbarItems}>
          {PRUEBAS_TOOLBAR.map((k: RouteKey) => (
            <ToolbarItem
              key={k}
              player={props.player}
              equipo={props.equipo}
              item={k}
            />
          ))}
        </div>
      </div>
    </React.Fragment>
  );
}

function getCurrentRoute(
  location: Location,
  player: Player
): ?(Player) => string {
  const key: ?RouteKey = PRUEBAS_TOOLBAR.find((key: RouteKey) =>
    isActiveRoute(location, key, player)
  );
  if (key) {
    return PRUEBAS_ROUTE[key];
  }
}

function isActiveRoute(location: Location, item: RouteKey, player: Player) {
  const route = PRUEBAS_ROUTE[item](player);
  return location.pathname.startsWith(route);
}

function isCorrect(equipo: Equipo, item: RouteKey): boolean {
  if (equipo.pruebas) {
    const prueba = equipo.pruebas[(item: string)];
    if (prueba) {
      return prueba.correct;
    }
  }
  return false;
}

function ToolbarItemFn({
  history,
  item,
  player,
  location,
  equipo,
}: {
  equipo: Equipo,
  player: Player,
  item: RouteKey,
  history: RouterHistory,
  location: Location,
}) {
  const route = PRUEBAS_ROUTE[item](player);
  const isActive = isActiveRoute(location, item, player);
  return (
    <div
      onClick={() => {
        history.push(route);
      }}
      className={classnames(
        styles.ToolbarItem,
        isActive && styles.ToolbarItemActive
      )}
    >
      <div className={styles.img}>
        {
          <img
            alt="Icon"
            src={
              isCorrect(equipo, item)
                ? imgSrc(`/images/robin-hood/toolbar/correct/${ICONOS[item]}`)
                : imgSrc(`/images/robin-hood/toolbar/${ICONOS[item]}`)
            }
          />
        }
      </div>
    </div>
  );
}
const ToolbarItem = withRouter(ToolbarItemFn);

class AvatarClass extends React.Component<{
  player: Player,
  equipo: Equipo,
  agent: Agent,
  store: RegisteredStore,
  history: RouterHistory,
  location: Location,
}> {
  _goToBase = () => {
    const { equipo, agent, history } = this.props;
    const players = getAgentPlayers(equipo, agent);
    if (players.length > 1) {
      history.push(PATHS.AGENTES());
    }
  };
  _goToPlayer = (newPlayer: Player) => {
    const { store, history, location, player } = this.props;
    if (knowsPlayerSecret(store, newPlayer)) {
      const currentRoute = getCurrentRoute(location, player);
      if (currentRoute) {
        history.push(currentRoute(newPlayer));
      }
    } else {
      history.push(PATHS.INICIAL(newPlayer));
    }
  };

  render() {
    const { player, equipo, agent } = this.props;
    const players = getAgentPlayers(equipo, agent);
    // First selected, then the rest
    const otherPlayers = players.filter((p) => p !== player);
    const otherClassName =
      otherPlayers.length === 1 ? styles.onlyOneOther : null;
    return (
      <div
        className={classnames(
          styles.ToolbarAvatar,
          equipo.endTime != null && styles.hideToolbar
        )}
      >
        <div className={styles.avatarsWrapper}>
          {otherPlayers.map((p) => (
            <img
              onClick={() => {
                this._goToPlayer(p);
              }}
              key={p}
              alt="Avatar"
              className={classnames(styles.avatarImg, otherClassName)}
              src={AVATAR_PLAYER.get(p)}
            />
          ))}
          <img
            key={player}
            alt="Avatar"
            className={classnames(styles.avatarImg, styles.avatarImgActive)}
            src={AVATAR_PLAYER.get(player)}
          />
        </div>
        <div className={styles.avatarNameWrapper} onClick={this._goToBase}>
          <span className={styles.avatarName}>{NAME_PLAYER.get(player)}</span>
        </div>
      </div>
    );
  }
}

const Avatar = withRouter(AvatarClass);
